import type { ApiResponse } from '@/types';

function getApiBaseUrl(): string {
  const envUrl = import.meta.env.VITE_API_URL;
  if (!envUrl) return '/api';
  if (envUrl.endsWith('/api')) return envUrl;
  return envUrl.replace(/\/$/, '') + '/api';
}

const API_BASE_URL = getApiBaseUrl();

async function request<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> {
  const token = localStorage.getItem('auth_token');

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    (headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
  }

  if (window.Telegram?.WebApp?.initData) {
    (headers as Record<string, string>)['X-Telegram-Init-Data'] = window.Telegram.WebApp.initData;
  }

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers,
  });

  const data: ApiResponse<T> = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.error || 'Unknown error');
  }

  return data.data as T;
}

// ============================================
// BATTERY A API
// ============================================

export interface SJTResponse {
  question: string;
  best: string;
  worst: string;
}

export interface FCResponse {
  question: string;
  choice: string;
}

export interface SCResponse {
  question: number;
  text: string;
}

export interface BatteryAProfile {
  primary: string;
  secondary: string;
  shadow: string;
  scores: Record<string, number>;
}

export interface BatteryAStartResponse {
  userId: string;
  totalQuestions: number;
  sections: Array<{ type: string; count: number; label: string }>;
}

export async function startBatteryA(): Promise<BatteryAStartResponse> {
  return request<BatteryAStartResponse>('/battery-a/start', {
    method: 'POST',
  });
}

export async function submitBatteryA(
  sjtResponses: SJTResponse[],
  fcResponses: FCResponse[],
  scResponses: SCResponse[],
): Promise<{ profile: BatteryAProfile }> {
  return request<{ profile: BatteryAProfile }>('/battery-a/sc', {
    method: 'POST',
    body: JSON.stringify({ sjtResponses, fcResponses, scResponses }),
  });
}

export async function getBatteryAResult(): Promise<{ profile: BatteryAProfile }> {
  return request<{ profile: BatteryAProfile }>('/battery-a/result');
}
